module.exports = __webpack_public_path__ + "img/inside.e79cbcca.png";